export default __webpack_public_path__ + "static/media/bitmap.6c271da4.png";